import io from "socket.io-client";

// Redux
import { receiveMsg, chatTransferred, chatTaken, chatFreed, chatClosed, chatTagged, contactUpdated } from "@Actions/chats";
import { callIncoming, callUpdated, callCleared, callTaken } from "@Actions/calls";
import userUpdated from "@Actions/user";
import companyUpdated from "@Actions/company";
import { showBrowserNotification } from "@Actions/notifications";

// eslint-disable-next-line import/no-mutable-exports
export let socket = null;

export function socketClose() {
	if (socket) {
		socket.close();
	}
}

export function socketInit({ userId = 0, userName = "", companyId = 0, dispatch = () => {}, logoutFunction = () => {} }) {
	let interval = null;
	socketClose();
	clearInterval(interval);
	socket = io.connect(`${import.meta.env.VITE_API_URL}`, {
		jsonp: false,
		secure: true,
		transports: ["websocket"],
		query: {
			platform: "web",
			userId,
			userName,
			companyId,
		},
	});

	interval = setInterval(() => {
		if (socket.connected) {
			socket.emit("heartbeat");
		}
	}, 60 * 1000); // 1 minute

	socket.on("receiveMsg", async (data) => {
		dispatch(receiveMsg(data));
		if (document.hidden) {
			await showBrowserNotification();
		}
	});

	const registerCallListener = (eventName, handler) => {
		socket.on(eventName, (data) => {
			handler(data);
		});
	};

	const incomingCallEvents = ["callIncoming", "callOutgoing"];
	const endedCallEvents = ["callTerminated", "callRejected", "callEnded"];

	incomingCallEvents.forEach((eventName) => {
		registerCallListener(eventName, (data) => {
			dispatch(callIncoming(data));
			if (document.hidden) {
				showBrowserNotification();
			}
		});
	});

	endedCallEvents.forEach((eventName) => {
		registerCallListener(eventName, (data) => {
			dispatch(callUpdated(data));
			dispatch(callCleared());
		});
	});

	socket.on("callTaken", (data) => {
		dispatch(callTaken(data));
	});

	socket.on("callUpdated", (data) => {
		dispatch(callUpdated(data));
	});

	socket.on("chatTaken", (data) => {
		dispatch(chatTaken(data));
	});

	socket.on("chatFreed", (data) => {
		dispatch(chatFreed(data));
	});

	socket.on("chatClosed", (channelCid) => {
		dispatch(chatClosed(channelCid));
	});

	socket.on("chatTransferred", (data) => {
		dispatch(chatTransferred(data));
	});

	socket.on("chatTagged", (data) => {
		dispatch(chatTagged(data));
	});

	socket.on("userUpdated", (data) => {
		dispatch(userUpdated(data));
	});

	socket.on("contactUpdate", (data) => {
		dispatch(contactUpdated(data));
	});

	socket.on("companyUpdated", (data) => {
		dispatch(companyUpdated(data));
	});

	socket.on("logout", () => {
		dispatch(callCleared());
		dispatch(logoutFunction(true));
	});

	socket.on("disconnect", () => {
		dispatch(callCleared());
	});
}
